<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>起止时间:</label>
            <timeStampDatePicker type="daterange" placeholder="请选择" v-model="query.date"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>对账结果:</label>
            <lk-select v-model='query.code' class="item" clearable style="width: 200px">
              <lk-option v-for="(item,index) in codeList" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button type='primary' @click='handleClick'>对账</lk-button>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import insurance from '../../../services/insuranceLanzhou';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';

export default {
  name: 'DetailAccountCheck',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {},
  data() {
    return {
      query: {
        beginTime: null,
        endTime: null,
        date: [],
        code: ''
      },
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '结算ID',
          key: 'setlId',
          minWidth: 116,
        },
        {
          title: '就诊ID',
          key: 'mdtrtId',
          minWidth: 116,
        },
        {
          title: '人员编号',
          key: 'psnNo',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '医疗费总额',
          key: 'medfeeSumamt',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '基金支付总额',
          key: 'fundPaySumamt',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '个人账户支出',
          key: 'acctPay',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '退费结算标志',
          key: 'refdSetlFlagName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '对账结果',
          key: 'stmtRsltName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '备注',
          key: 'memo',
          minWidth: 116,
          tooltip: true,
        },
      ],
      tableData: [],
      codeList: [
          {
            id: '0',
            name: '平'
          },
          {
            id: '1',
            name: '不平'
          },
        ]
    };
  },
  methods: {
    handleReset() {
      this.query = {
        beginTime: null,
        endTime: null,
        date: [],
        code: ''
      };
    },
    handleClick() {
      this.page = 1;
      this.params.page = this.page;
      this.params.code = this.query.code;
      if (!this.query.date.length) {
        delete this.params.date;
        this.params.beginTime = null;
        this.params.endTime = null;
      } else {
        this.params.beginTime = this.query.date[0] || null;
        this.params.endTime = this.query.date[1] || null;
      }
      if(!this.params.beginTime || !this.params.endTime) {
        this.$Message.error('请先选择查询日期');
        return;
      }
      insurance.checkDetail(this.params).then(res => {
        if (res.data.status === 200) {
          this.tableData = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.date) {
        this.params.beginTime = this.params.date[0];
        this.params.endTime = this.params.date[1];
      }
      delete this.params.date;
      if(!this.params.beginTime || !this.params.endTime) {
        this.$Message.error('请先选择查询日期');
        return;
      }
      insurance.getDetail(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
  .btns {
    margin-bottom: 8px;
    >* {
      margin-right: 8px
    }
  }
</style>
